'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../api/\u610F\u50B3\u670D\u52D9');

var _2 = _interopRequireDefault(_);

var _CustomProptype = require('../vendor/CustomProptype');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayButton = function (_React$Component) {
  _inherits(PlayButton, _React$Component);

  function PlayButton(props) {
    _classCallCheck(this, PlayButton);

    var _this = _possibleConstructorReturn(this, (PlayButton.__proto__ || Object.getPrototypeOf(PlayButton)).call(this, props));

    _this.state = {
      isPlaying: false,
      isError: false
    };
    return _this;
  }

  _createClass(PlayButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src === this.props.src) return;
      var 音檔 = this.合成音檔;
      音檔.load();
      this.setState({ isPlaying: false });
    }
  }, {
    key: 'play',
    value: function play() {
      var 音檔 = this.合成音檔;
      音檔.play();
    }
  }, {
    key: 'handlePlay',
    value: function handlePlay() {
      this.setState({ isPlaying: true });
    }
  }, {
    key: 'handleEnd',
    value: function handleEnd() {
      this.setState({ isPlaying: false });
    }
  }, {
    key: 'handleError',
    value: function handleError(e) {
      this.setState({ isError: true });
    }
  }, {
    key: 'btnStyle',
    value: function btnStyle() {
      var color = '';
      if (this.state.isError) {
        color = 'disabled negative';
      } else if (this.state.isPlaying) {
        color = 'grey';
      }
      return 'ui compact icon massive button ' + color;
    }
  }, {
    key: 'iconStyle',
    value: function iconStyle() {
      if (this.state.isError) {
        return 'icon-attention-alt';
      }
      return 'icon-play';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          src = _props.src,
          children = _props.children;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'audio',
          { ref: function ref(a) {
              _this2.合成音檔 = a;
            },
            onPlay: this.handlePlay.bind(this),
            onEnded: this.handleEnd.bind(this),
            onError: this.handleError.bind(this) },
          _react2.default.createElement('source', { type: 'audio/wav', src: src })
        ),
        _react2.default.createElement(
          'button',
          { onClick: this.play.bind(this),
            className: this.btnStyle() },
          _react2.default.createElement('i', { className: this.iconStyle() }),
          children
        )
      );
    }
  }]);

  return PlayButton;
}(_react2.default.Component);

PlayButton.propTypes = {
  src: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

exports.default = PlayButton;


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/lib/component/PlayButton.js
// module id = 513
// module chunks = 0